// React
import { useState } from "react";

// OpenLayers
import OlMap from "ol/Map";

// Tools
import { assetURL, getFlagAssetName } from "lib/utilities/asset";

// Models
import Locale from "lib/interfaces/locale";

import { Popup, PopupProps } from "lib/classes/popup";
import { getLocaleString } from "lib/localization/vendor";

const LocalesPopup = new Popup({
	title: () => getLocaleString("locales"),
	distinct: true,
	render: function() {
		const map:OlMap = this.get("map");
		const mapConfig:any = map.get("opus-config");
		const locales:Locale[] = mapConfig.locales;
		const activeLocale:Locale = _config.lang.locale;
		
		const [currentLocale, setCurrentLocale] = useState<Locale>(activeLocale);
			
		// On new map config loaded for new locale
		_events.on("new-map-config", () => {
			_ui.closePopupOf(this); // Hide locale selector
			_ui.hideLoading(); // Hide loading
		});
		
		const selectLocale = (locale:Locale) => {
			if(locale == currentLocale) {
				_ui.closePopupOf(this);
				return;
			}
			
			_ui.showLoading();
			
			_config.lang.setLanguageId(locale.code, (res:boolean) => {
				//_ui.hideLoading(); // Don't hide loading, this will be called when the new map config is loaded in config/map
				
				if(!res) {
					_ui.showError(getLocaleString("errlangset"));
					return;
				}
				
				setCurrentLocale(locale);
			});
		}
		const drawOptions = () => {
			const rows:Array<any> = [];
			
			locales.forEach((locale:Locale) => {
				const flagAsset:string = getFlagAssetName(locale.code);
				
				let className:string = "unit-option";
				
				if(locale.code == currentLocale.code)
					className += ` unit-option--selected ${_ui.getSelClassName()}`;
				
				rows.push(
					<div 
						className={className}
						key={locales.indexOf(locale)} 
						onClick={() => selectLocale(locale)}
					>
						<img 
							src={assetURL(`assets/images/flags/${flagAsset}.png`)} 
							className='flag'
						/>
						{locale.name}
					</div>
				);
			});
			
			return rows;
		}
		
		return (
			<>
				{drawOptions()}
			</>
		)
	}
});

export default LocalesPopup;